import React from 'react';
import { Field, FieldProps } from 'formik';
import { TextField } from '@mui/material';

interface FormikTextFieldProps {
  name: string;
  label: string;
  type?: 'text' | 'number' | 'password';
  placeholder?: string;
  helperText?: string;
  isRequired?: boolean;
  autoFocus?: boolean;
  disabled?: boolean;
}

const FormikTextField: React.FC<FormikTextFieldProps> = ({
  name,
  label,
  type = 'text',
  placeholder,
  helperText,
  isRequired = false,
  autoFocus = false,
  ...textFieldProps
}) => {
  return (
    <Field name={name}>
      {({ field, meta }: FieldProps) => (
        <div className='w-full relative '>
          <TextField
            {...field}
            type={type}
            label={label}
            size='small'
            placeholder={placeholder}
            error={meta.touched && Boolean(meta.error)}
            helperText={meta.touched && meta.error ? meta.error : helperText}
            fullWidth
            variant='standard'
            autoFocus={autoFocus}
            autoComplete='new-password'
            InputLabelProps={{
              shrink: true, // Ensures the label is always shrunk
            }}
            sx={{
              '& label': {
                fontSize: 'medium',
                //  color: meta.touched && meta.error ? "red" : "white",
                fontWeight: '500',
                '&::after': {
                  content: isRequired ? '" *"' : '""', // Add asterisk if required
                  color: 'red',
                },
                color: meta.touched && meta.error ? 'red' : 'primary.main',
              },
              '& .MuiFormHelperText-root': {
                position: 'absolute',
                bottom: '-20px',
              },
            }}
            {...textFieldProps}
          />
        </div>
      )}
    </Field>
  );
};

export default FormikTextField;
